import { useQueryParams } from '@calendly/hooks'
import { UserMultipleIcon } from '@calendly/ui/components/icons'

import { UserInfoAvatar } from 'features/user_profiles'

import { NewWorkflowButton } from './new_workflow_button'
import { ListHeader } from '../../../../styles/layout'
import {
  HeaderProfile,
  HeaderTitle,
  TeamSizeContainer
} from '../../../../styles/owner_list_item'


export const Header = ({ owner }) => {
  const {
    type: ownerType,
    can_manage_workflows: canManageWorkflows
  } = owner
  const { admin_managed: adminManaged } = useQueryParams()

  return (
    <ListHeader>
      <HeaderProfile>
        <UserInfoAvatar
          src={owner.avatar_url}
          letter={owner.avatar_letter}
          uuid={owner.uuid}
          name={owner.name}
          isNonInteractive={ownerType.toLowerCase() !== 'user'}
        />
        <HeaderTitle>
          {owner.name}
        </HeaderTitle>
        {ownerType === 'page' && (
          <TeamSizeContainer>
            <UserMultipleIcon />
            {owner.team_size}
          </TeamSizeContainer>
        )}
      </HeaderProfile>
      {canManageWorkflows && !adminManaged && <NewWorkflowButton owner={owner} />}
    </ListHeader>
  )
}
